import {
    Button,
    Card,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Select,
    TextField,
} from "@mui/material";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import styled from "styled-components";
import { PrimaryButton } from "../../Layouts/ButtonsControlled";
import { FormHeading } from "../../Layouts/Heading";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { getAllState, resetState } from "../../Redux/StateSlice/stateSlice";
import {
    contractorsReset,
    CreateNewContractor,
} from "../../Redux/ContractorSlice/ContractorSlice";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";

const CreateContractor = () => {
    const dispatch = useDispatch();
    const { isLoading, isSuccess, isError, errors } = useSelector(
        (state) => state.contractors
    );
    const errorsObj = errors || [];
    const { states, isStateSuccess, isStateErorr, isStatesloading } =
        useSelector((state) => state.AllStates);

    const AllStates = states?.data?.states;

    // get all states
    useEffect(() => {
        const getStates = async () => {
            await dispatch(getAllState());
            await dispatch(resetState());
        };
        getStates();
    }, []);

    const [substates, setStates] = useState([]);

    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        setStates(typeof value === "string" ? value.split(",") : value);
    };

    const validationSchema = yup.object({
        // name: yup.required("Name Field Is Required").string("ter");
    });
    const initialValues = {
        name: "",
        address: "",
        status: "",
        expiry_date: "",
        entity: "",
        license: "",
        initial: "",
        states: [],
    };
    const formik = useFormik({
        initialValues,
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            await dispatch(
                CreateNewContractor({ ...values, states: substates })
            );
            await dispatch(contractorsReset());
        },
    });

    useEffect(() => {
        if (isError) {
            if (errorsObj) {
                Object.keys(errorsObj).forEach((key) => {
                    let error = errorsObj[key][0];
                    toast.error(error);
                });
            }
            const reset = async () => {
                await dispatch(contractorsReset());
            };
            reset();
        }
    }, [isError]);

    useEffect(() => {
        if (isSuccess) {
            toast.success("A contractor has been added successfully");
            formik.values = {
                name: "",
                address: "",
                status: "",
                expiry_date: "",
                entity: "",
                license: "",
                initial: "",
                states: [],
            };
            const reset = async () => {
                await dispatch(contractorsReset());
            };
            reset();
        }
    }, [isSuccess]);

    return (
        <>
            {isLoading && <LoadingAnimation />}
            {!isLoading && (
                <FormContainer>
                    <FormHeading> Add New Contractor </FormHeading>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container columns={12} spacing={3}>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="name"
                                    name="name"
                                    label="Name"
                                    value={formik.values.name}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.name &&
                                        Boolean(formik.errors.name)
                                    }
                                    helperText={
                                        formik.touched.name &&
                                        formik.errors.name
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="address"
                                    name="address"
                                    label="Address"
                                    value={formik.values.address}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.address &&
                                        Boolean(formik.errors.address)
                                    }
                                    helperText={
                                        formik.touched.address &&
                                        formik.errors.address
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <FormControl fullWidth required={true}>
                                    <InputLabel id="demo-simple-select-label">
                                        State
                                    </InputLabel>
                                    <Select
                                        id="status"
                                        name="status"
                                        label="Status"
                                        value={formik.values.status || ""}
                                        onChange={formik.handleChange}
                                    >
                                        <MenuItem value="active">
                                            Active
                                        </MenuItem>
                                        <MenuItem value="inactive">
                                            Inactive
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="expiry_date"
                                    name="expiry_date"
                                    label="Expiry Date"
                                    type="date"
                                    value={formik.values.expiry_date}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.expiry_date &&
                                        Boolean(formik.errors.expiry_date)
                                    }
                                    helperText={
                                        formik.touched.expiry_date &&
                                        formik.errors.expiry_date
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="entity"
                                    name="entity"
                                    label="Entity"
                                    value={formik.values.entity}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.entity &&
                                        Boolean(formik.errors.entity)
                                    }
                                    helperText={
                                        formik.touched.entity &&
                                        formik.errors.entity
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="license"
                                    name="license"
                                    label="License"
                                    value={formik.values.license}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.license &&
                                        Boolean(formik.errors.license)
                                    }
                                    helperText={
                                        formik.touched.license &&
                                        formik.errors.license
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="initial"
                                    name="initial"
                                    label="Initial"
                                    value={formik.values.initial}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.initial &&
                                        Boolean(formik.errors.initial)
                                    }
                                    helperText={
                                        formik.touched.initial &&
                                        formik.errors.initial
                                    }
                                />
                            </Grid>

                            <Grid item mb={2} xs={12} md={6}>
                                <FormControl fullWidth>
                                    <InputLabel id="states-label">
                                        States
                                    </InputLabel>
                                    <Select
                                        labelId="states-label"
                                        id="states"
                                        multiple
                                        value={substates}
                                        onChange={handleChange}
                                        required={true}
                                        input={<OutlinedInput label="Name" />}
                                        // MenuProps={MenuProps}
                                    >
                                        {AllStates?.map((key, index) => (
                                            <MenuItem
                                                key={index}
                                                value={key?.id}
                                            >
                                                {key?.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>

                        <PrimaryButton fullWidth type="submit">
                            {isLoading ? "loading ... " : " Add New Contractor"}
                        </PrimaryButton>
                    </form>
                </FormContainer>
            )}
        </>
    );
};

const FormContainer = styled.div`
    padding: 1rem;
`;
export default CreateContractor;
